import axios from '../library/axiosConfig'

export default {
  brokerRecommend(data) {
    return axios.post('/v2/find/recommend/brokerRecommend', data)
  },
  districtAndSubway(data) {
    return axios.post('/v2/find/filter/districtAndSubway', data)
  },
  getRoomListByCriteria(data) {
    return axios.post('/v2/find/getRoomListByCriteria', data)
  },
  //筛选结果为空时推荐房源列表接口
  getRecommendRoom(data) {
    return axios.post('/v2/find/getRecommendRoom', data)
  },
  // 房间详情baseInfo
  roomDefailBaseInfo(data, config) {
    return axios.post('/v2/find/roomDetail/basicInfo', data, config)
  },

  // 房间详情室友信息
  roomDefailQueryRoommatesByRoomId(data, config) {
    return axios.post('/v2/find/roomMates/queryRoommatesByRoomId', data, config)
  },
  //房间详情卡券接口
  getPromotions(data) {
    return axios.post(`/v2/find/roomDetail/promotions`, data, {baseURL: axios.defaults.roomFindWeb})
  },
  // 房间详情经纪人信息以及平台保障
  ownerPlatformEnsureInfo(data) {
    return axios.post('/v2/find/roomDetail/ownerPlatformEnsureInfo', data)
  },
  // 房间详情经纪人信息以及平台保障BrandCustom
  ownerPlatformEnsureInfoBrandCustom(data) {
    return axios.post('/h5/brandcustom/v1/ownerPlatformEnsureInfo', data, {})
  },
  // 房间详情位置信息
  subwayLocation(data) {
    return axios.post('/v2/find/roomDetail/subwayLocation', data)
  },
  // 房间详情同小区房源
  sameCommunityHouses(data) {
    return axios.post('/v2/find/roomDetail/sameCommunityHouses', data)
  },
  // 房间详情相似房源
  similarHouses(data) {
    return axios.post('/v2/find/roomDetail/similarHouses', data)
  },
  // 房间详情同品牌房源
  sameBrandHouse(data) {
    return axios.post('/h5/brandcustom/v1/recommend/sameBrandHouses', data, {baseURL: axios.defaults.custSeek})

  },
  // 房间详情同小区房源
  sameCommunityHousesRecommend(data) {
    return axios.post('/v2/find/recommend/sameCommunityHouses', data)
  },
  // 房间详情相似房源
  similarHousesRecommend(data) {
    return axios.post('/v2/find/recommend/similarHouses', data)
  },
  // 银联首页热门房源
  getHotRooms(cityId) {
    return axios.post(`/v2/find/home/unionpay?cityId=${cityId}`)
  },
  // 房间详情房间配置
  // roomId
  getRoomConfigs(data) {
    return axios.post(`/v2/find/roomDetail/roomConfigs`, data)
  },
  // 房间详情房间配置BrandCustom
  // roomId
  getRoomConfigsBrandCustom(data) {
    return axios.post(`/h5/brandcustom/v1/roomConfigs`, data, {})
  },
  // 房间号筛选获取接口
  // sourceType 房源渠道：1:经纪人 2:蘑菇 (默认:2)
  // roomId
  selectRoomNos(data) {
    return axios.post(`/v2/find/roomDetail/selectRoomNos`, data)
  },

  getLandlordInfo(data) {
    return axios.post(`/v2/find/roomSupplierSearch/getLandordInfo`, data)
  },
  /* 315新首页 */
  // 获取banner和头条
  getMarketing(cityId) {
    return axios.post(`/v2/find/home/marketing?cityId=${cityId}`)
  },
  // 获取精选经纪人
  getFeaturedBrokers(cityId) {
    return axios.post(`/v2/find/home/featuredbrokers?cityId=${cityId}`)
  },
  // 精选业主房源
  getBrokerRooms(cityId) {
    return axios.post(`/v2/find/home/brokerrooms?cityId=${cityId}`)
  },
  // 优选品牌公寓
  getFeaturedBrands(cityId) {
    return axios.post(`/v2/find/home/featuredbrands?cityId=${cityId}`)
  },
  // 优选公寓房源
  getLandlordRooms(cityId) {
    return axios.post(`/v2/find/home/landlordrooms?cityId=${cityId}`)
  },
  // 店铺活动
  getStoreActivities(data) {
    return axios.post(`/v1/find/h5/getBrandActivities`, data)
  },
  /**
   * 热门地区标签
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getHotTags(data) {
    return axios.post(`/v2/find/getHotBusinessArea`, data)
  },
  /**
   * 搜索联想
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getFuzzy(data) {
    return axios.post(`/v2/find/fuzzy`, data)
  },
  getBannerAdsInfo(data) {
    return axios.post(`/v2/find/brand/getBannerAdsInfo`, data)
  },
  getChoiceKaBrand(data) {
    return axios.post(`/v2/find/home/getChoiceKaBrand`, data)
  },
  nearbyRooms(data) {
    return axios.get(`/find/v2/nearbyRooms`, {params: data})
  },
  // 一键租房
  instantFindRooms (data) {
    return axios.post('/find/v3/instantFindRooms', data)
  },
  // 一键租房-店铺列表
  selectedBrands (data) {
    return axios.post('/find/v3/selectedBrands', data)
  },
  // 一键租房-经纪人列表
  selectedBrokers (data) {
    return axios.post('/find/v3/selectedBrokers', data)
  },
  // 根据经纬度获取地理位置信息
  geoLocation(data) {
    return axios.post('/find/v3/filter/geoLocation', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/mogoroomFind.js